import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: '-10px',
    marginBottom: '1rem'
  },

  gridContainer: {
    display: 'grid',
    // Creates two equal width columns
    gridTemplateColumns: 'repeat(2, 1fr)',
    width: '100%',
    fontSize: theme.size.sm,

    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexDirection: 'column'
    }
  },

  group: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    overflow: 'auto',

    [theme.breakpoints.down('md')]: {
      fontSize: theme.size.sm
    }
  },

  groupBorder: {
    '& > .cf-group:not(:first-child)': {
      borderTop: `1px solid ${theme.border.separator}`,
      boxSizing: 'border-box',
      paddingBottom: '1rem'
    }
  },

  title: {
    flexBasis: '100%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    paddingTop: '1.5rem',
    color: '#323436',
    fontSize: theme.size.sm,
    '& > :nth-child(1)': {
      textTransform: 'capitalize'
    },

    '& > :nth-child(2)': {
      opacity: '0.35',
      color: '#323436',
      fontSize: theme.size.sm,
      fontStyle: 'italic'
    },

    [theme.breakpoints.down('lg')]: {
      paddingTop: '0',
      paddingBottom: '0.5rem'
    }
  },

  arrow: {
    margin: '1rem 0 1.5rem 0',
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: theme.size.sm
  }
}))

export default useStyles
